import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "link",
  "use": "link-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"link\"><title>link</title><path d=\"M11.88 6.34l-.95.95A3.15 3.15 0 0 1 12 12.46l-5.35 5.35a3.16 3.16 0 0 1-4.46-4.46l2.23-2.23-.89-.89-2.24 2.23a4.42 4.42 0 0 0 6.25 6.25l5.36-5.36a4.41 4.41 0 0 0-1-7zm6.83-5a4.42 4.42 0 0 0-6.25 0L7.1 6.65a4.42 4.42 0 0 0 1 7l.95-1A3.15 3.15 0 0 1 8 7.54l5.36-5.36a3.16 3.16 0 0 1 4.46 4.46l-2.24 2.24.89.89 2.23-2.23a4.42 4.42 0 0 0 .01-6.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/link.svg
// module id = s3+7
// module chunks = 6